export const PageOptions = [
  {label: 10, value: 10},
  {label: 20, value: 20},
  {label: 30, value: 30},
  {label: 40, value: 40},
  {label: 50, value: 50},
];

export interface Option {
  value: any;
  label: any
}

export const RowsPerPageOptions = [
  10,
  20,
  30,
  40,
  50
];
